import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../utils/network/generated/protoTypes";
import { actionPlayerInfoChangeProfilePicture } from "../info/player/actionPlayerInfo";
import { TypeActionPlayerProfilePicture, } from "./actionPlayerProfilePicture";
export var epicSelectProfilePicture = function (action$, state$, deps) {
    var newPlayerProfilePictureId = 1;
    return action$.pipe(ofType(TypeActionPlayerProfilePicture.Set), switchMap(function (action) {
        newPlayerProfilePictureId = action.profilePictureId;
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        return deps.netSend({
            id: CommandCode.ChoosePlayerProfilePicture,
            props: {
                newPlayerProfilePictureId: newPlayerProfilePictureId,
                playerId: playerId,
            },
        });
    }), retry(), map(function () { return actionPlayerInfoChangeProfilePicture(newPlayerProfilePictureId); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/profile-picture/epicSelectProfilePicture.ts
// module id = 2104
// module chunks = 3